export const sanitizeTournamentName = (name?: string): string => {
  if (!name) return "Unnamed Tournament";
  const regex = /\[(\d+)\]\s*(.*?)\s*\[(\d+)\]/;
  const match = regex.exec(name);
  return match ? match[2] : name;
};

export const parseTournamentName = (name: string) => {
  const regex = /\[(\d+)\]\s*(.*?)\s*\[(\d+)\]/;
  const match = regex.exec(name);
  if (match) {
    return {
      sponsoredBy: parseInt(match[1], 10),
      name: match[2],
      tournamentToplist: parseInt(match[3], 10),
    };
  } else {
    return {
      sponsoredBy: null,
      name: sanitizeTournamentName(name),
      tournamentToplist: null,
    };
  }
};

const normalizeInternationalCharacters = (str: string): string => {
  const charMap: { [key: string]: string } = {
    å: "a",
    ä: "a",
    ö: "o",
    Å: "A",
    Ä: "A",
    Ö: "O",
    é: "e",
    è: "e",
    ê: "e",
    ë: "e",
    É: "E",
    È: "E",
    Ê: "E",
    Ë: "E",
    ü: "u",
    Ü: "U",
    ß: "ss",
  };

  return str.replace(/[åäöÅÄÖéèêëÉÈÊËüÜß]/g, (match) => charMap[match] || match);
};

export const generateTournamentSlug = (tournamentId?: number, name?: string): string => {
  if (!tournamentId || !name) return "tournament";
  const sanitizedName = sanitizeTournamentName(name);
  const normalizedName = normalizeInternationalCharacters(sanitizedName);
  const slug = normalizedName
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return `${tournamentId}-${slug}`;
};
